module.exports = "\r\n.contenedor {\r\n  border-radius: 0.5em;\r\n  background-color: white;\r\n  padding: 1.5em;\r\n  margin: 1em 1.5em !important;\r\n}\r\n"